import React, {useEffect} from 'react'
import View from './view'
import {useIntercom} from 'react-use-intercom'
import {useSelector} from 'react-redux'
import {selectMember} from '../../../redux/members'

type Props = {
  children: React.ReactNode
  hideIntercom?: boolean
}

const NewWrapper = ({children, hideIntercom}: Props) => {
  const {boot: bootIntercom} = useIntercom()

  const member = useSelector(selectMember)

  useEffect(() => {
    try {
      const intercomData = member
        ? {
            name: member.firstName + ' ' + member.lastName,
            email: member.email,
            userId: member.id,
            createdAt: new Date(member.createDate).toISOString(),
            userHash: member.intercomHash,
            customAttributes: {
              account_cga_group:
                member.groupAccounts && member.groupAccounts?.length > 0
                  ? member.groupAccounts[0].organizationName
                  : null,
              account_cga_admin: member.cgaAdmin === 1,
              stripe_plan_new: member.stripePlan,
              stripe_subscription_status_new: member.stripeSubscriptionStatus,
            },
          }
        : {}

      if (!hideIntercom) bootIntercom(intercomData)
    } catch (error) {
      console.error(error)
    }
  }, [bootIntercom, member])

  return <View children={children} />
}

export default NewWrapper
